/* naawm / Nox — rotation automatique des USPs (mobile uniquement, ~0,6 Ko) */
(function () {
  if (window.__noxUsp) return;
  window.__noxUsp = true;

  function init() {
    document.querySelectorAll('[data-nox-usp-rotate]:not(.nox-usp-armed)').forEach(function (list) {
      list.classList.add('nox-usp-armed');
      var mq = window.matchMedia('(max-width: 719px)');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var items = [].slice.call(list.children);
      if (items.length < 2) return;

      var speed = (parseFloat(list.dataset.speed) || 3) * 1000;
      var current = 0;
      var timer = null;

      var dots = document.createElement('div');
      dots.className = 'nox-final__dots';
      items.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'USP ' + (i + 1));
        b.addEventListener('click', function () {
          show(i);
          restart();
        });
        dots.appendChild(b);
      });
      list.after(dots);

      function show(i) {
        current = (i + items.length) % items.length;
        items.forEach(function (el, j) {
          el.classList.toggle('is-on', j === current);
        });
        [].forEach.call(dots.children, function (d, j) {
          d.classList.toggle('is-on', j === current);
        });
      }

      function tick() {
        show(current + 1);
      }

      function restart() {
        if (timer) clearInterval(timer);
        if (mq.matches && !reduced.matches) timer = setInterval(tick, speed);
      }

      function apply() {
        if (mq.matches) {
          list.classList.add('nox-usps--rotate');
          dots.style.display = '';
          show(current);
          restart();
        } else {
          list.classList.remove('nox-usps--rotate');
          dots.style.display = 'none';
          if (timer) clearInterval(timer);
        }
      }

      mq.addEventListener('change', apply);
      apply();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
